import mockPlan from "./mockPlan";
import mockMachines from "./mockMachines";

const riskRealizedFactor = {
  Baixo: 0.98,
  Médio: 0.93,
  Alto: 0.86,
};

const machineRiskMap = Object.fromEntries(
  mockMachines.map((machine) => [machine.id, machine.riskLevel])
);

const mockRealized = mockPlan.map((planRow, index) => {
  const risk = machineRiskMap[planRow.machineId] || "Médio";
  const wobble = 0.96 + ((index % 5) - 2) * 0.02;
  const realizedUnits = Math.max(
    0,
    Math.round((planRow.planUnits || 0) * (riskRealizedFactor[risk] || 0.9) * wobble)
  );

  return {
    id: `real_${planRow.period}_${planRow.machineId}`,
    period: planRow.period,
    machineId: planRow.machineId,
    realizedUnits,
  };
});

export default mockRealized;
